<template>
  <div class="product-details-content-category-modal p-5">
    <form @submit.prevent="submit">
      <div class="d-flex align-items-center justify-content-between pb-3">
        <span class="fs-18">
          {{ category.name ? "Editar Categoria" : "Adicionar Categoria" }}
        </span>
        <button class="btn btn-sm btn-square" @click.prevent="$emit('close')">
          <i class="icon-x fs-20 text-secondary" />
        </button>
      </div>

      <form-group
        v-model="form.name"
        :errors="errors.name"
        id="name"
        type="text"
        label="Nome da categoria"
        placeholder="Digitar um título"
        disable-autocomplete
      />
      <div class="small-text text-secondary">
        <div class="d-flex w-100 align-items-center justify-content-between">
          <span>
            O nome da categoria aparece na sua área de membros
          </span>
          <span :class="{ 'text-danger': form.name.length > 70 }">
            {{ `${form.name.length}/70` }}
          </span>
        </div>
        <span v-if="form.name.length > 70" class="text-danger">
          O nome da categoria não deve conter mais que 70 caracteres
        </span>
      </div>

      <div class="d-flex justify-content-end">
        <button
          class="btn btn-secondary btn-new-secondary px-6 mr-3 my-3"
          @click="$emit('close')"
          type="button"
        >
          Cancelar
        </button>
        <button
          class="btn btn-primary btn-primary px-6 ml-3 my-3 "
          type="submit"
          :disabled="form.name.length > 70"
        >
          <loading :show="loading">
            Salvar
          </loading>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers";

export default {
  props: {
    category: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      ...formFields(["name", "product_id"], {
        name: this.category.name ? this.category.name : "",
        product_id: this.$route.params.id
      })
    };
  },
  methods: {
    submit() {
      this.loading = true;
      if (!this.category.name) {
        this.$store
          .dispatch("membersCategories/post", this.form)
          .then(response => {
            this.$message.success("Salvo com sucesso");
            this.$emit("success", response.data);
          })
          .catch(error => {
            this.errors = error?.response?.data || this.errors;
            this.handleErrors(error, "", "Erro ao salvar categoria");
            this.loading = false;
          });
      } else {
        this.form.id = this.category.id;
        this.$store
          .dispatch("membersCategories/put", this.form)
          .then(() => {
            this.$message.success("Editado com sucesso");
            this.$emit("success");
          })
          .catch(error => {
            this.errors = error?.response?.data || this.errors;
            this.handleErrors(error, "", "Erro ao salvar categoria");
            this.loading = false;
          });
      }
    }
  }
};
</script>
